import React from "react";

function Editor(props) {
  const { data } = props;
  return (
    <div className="col-xl-12">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Editors</h5>
          <hr />
          <div className="row separate-row">
            <div className="col-sm-6">
              <div className="job-icon pb-2">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{data?.total_editors ?? 0}</h2>
                  <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                </div>
                <div className="fs-14 d-block mb-2">Total Editor</div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pb-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{data?.active_editors ?? 0}</h2>
                    <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                  </div>
                  <div className="fs-14 d-block mb-2">Active Editor</div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{data?.inactive_editors ?? 0}</h2>
                    <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                  </div>
                  <div className="fs-14 d-block mb-2">Inactive Editor</div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{data?.today_editors ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${data?.today_editors_flag}`}
                    ></i>
                  </div>
                  <div className="fs-14 d-block mb-2">Today's Editor</div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{data?.jobs_by_editors ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${data?.jobs_by_editors_flag}`}
                    ></i>
                  </div>
                  <div className="fs-14 d-block mb-2">Editor Jobs</div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Editor;
